
// If you want to add a new type, you also need to add it inside MentionHelper.js and RenderedMention.js
export const MentionType = {
    USER: "MentionType.USER"
};